module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/7448a54a65c39243c0bd851d9fe5dc62.png";